import { dispatchAppAction } from '../../runtimeBridge'
import { useI18n } from '../../i18n'
import { syncBannerState } from '../../state/appUiStore'

/**
 * Renders the cloud-sync status and retry banner.
 *
 * @returns The banner element.
 */
const SyncStatusBanner = () => {
   const t = useI18n()

   return (
      <div
         id="sync-status-banner"
         class="hidden lg:col-span-2 mb-3 flex flex-col gap-1 rounded-xl border border-amber-400/40 bg-amber-900/40 px-4 py-3 text-amber-100 text-sm"
         classList={{ hidden: !syncBannerState().visible }}
         role="status"
         aria-live="polite"
      >
         <p id="sync-status-message" class="font-semibold">
            {syncBannerState().message || t('Cloud sync delayed')}
         </p>
         <p id="sync-status-detail" class="text-xs text-amber-200/80">
            {syncBannerState().detail}
         </p>
         <div class="flex items-center gap-3 pt-1">
            <button
               type="button"
               id="sync-retry-now"
               onClick={() => dispatchAppAction({ action: 'retry-sync-now' })}
               class="inline-flex items-center gap-1 rounded-md border border-amber-300/60 px-3 py-1 text-xs font-semibold text-amber-100 transition hover:bg-amber-500/10 focus:outline-none focus:ring-2 focus:ring-amber-300/80"
            >
               {t('Retry now')}
            </button>
            <span id="sync-status-timestamp" class="text-[11px] text-amber-200/70">
               {syncBannerState().timestamp}
            </span>
         </div>
      </div>
   )
}

export default SyncStatusBanner
